import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';

class Table extends React.PureComponent {
    static propTypes = {
        dataSource: PropTypes.array,
        columns: PropTypes.array,
        emptyText: PropTypes.string,
    };

    static defaultProps = {
        emptyText: '暂无数据',
    };

    state = {
        formatDataSource: this.formatDataSource,
        _dataSource: [],
        tempDataSource: [],
    };

    ref = React.createRef();
    ref_tbody = React.createRef();

    componentDidMount = () => {
        addEventListener(window, 'scroll', this.handleWindowScroll);
    };

    handleWindowScroll = () => {
        const thead = this.ref.current;
        const tbody = this.ref_tbody.current;
        const reference = thead.getBoundingClientRect();
        const markTop = tbody.getBoundingClientRect().top;

        if (markTop <= 0) {
            thead.style.position = 'fixed';
            thead.style.top = 0;
            thead.style.width = '1000px';
        } else {
            thead.style.position = 'absolute';
            thead.style.top = 0;
            thead.style.width = '1000px';
        }
    };

    // 更新表格数据
    static getDerivedStateFromProps = (props, state) => {
        let resTemp = {};
        let resData = {};

        if (props.dataSource !== state.tempDataSource) {
            try {
                const { columns } = props;

                // 深拷贝一下
                const new_dataSource = JSON.parse(JSON.stringify(props.dataSource));

                for (let i = 0; i < columns.length; i++) {
                    const c_item = columns[i];

                    for (let j = 0; j < new_dataSource.length; j++) {
                        const d_item = new_dataSource[j];

                        if (!d_item[c_item.dataIndex] && d_item[c_item.dataIndex] !== 0) {
                            d_item[c_item.dataIndex] = null;
                        }
                    }
                }

                resData = { _dataSource: new_dataSource };
                resTemp = { tempDataSource: props.dataSource };
            } catch (e) {
                console.error(e);
            }
        }

        return { ...resData, ...resTemp };
    };

    // 渲染数据列表
    renderRow(item, index) {
        const { dataSource, columns } = this.props;

        try {
            return (
                columns &&
                columns.map((ele, i) => {
                    // if (item[ele.dataIndex] || item[ele.dataIndex] === 0 || item[ele.dataIndex] === '') {
                    const rowContent = item[ele.dataIndex];
                    const rowRender = ele.render || '';

                    const inheritTxtAlign = ele.textAlign ? ele.textAlign : '';

                    if (rowRender) {
                        return (
                            <td key={i} style={{ textAlign: inheritTxtAlign }}>
                                {(() => {
                                    return rowRender(rowContent, dataSource[index], ele.dataIndex, index);
                                })()}
                            </td>
                        );
                    }

                    return (
                        <td key={i} style={{ textAlign: inheritTxtAlign }}>
                            {rowContent}
                        </td>
                    );
                    // } else {
                    //     return <td key={i} />;
                    // }
                })
            );
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { columns, dataSource, emptyText } = this.props;
        const { _dataSource } = this.state;

        // console.log(columns);

        return (
            <React.Fragment>
                <div className={styles.table}>
                    <div className={styles.thead_wrapper} ref={this.ref}>
                        <table>
                            <thead className={styles.thead}>
                                <tr>
                                    {columns &&
                                        Array.isArray(columns) &&
                                        columns.map((item, index) => {
                                            return (
                                                <td
                                                    className={styles.td}
                                                    key={index}
                                                    style={{
                                                        width: item.width ? `${item.width}px` : '',
                                                        textAlign: item.textAlign ? item.textAlign : '',
                                                    }}
                                                    data-col-index={index}>
                                                    {item.title}
                                                </td>
                                            );
                                        })}
                                </tr>
                            </thead>
                            <tbody>
                                {_dataSource && _dataSource.length
                                    ? _dataSource.map((item, index) => {
                                          return (
                                              <tr key={index} ref={`row-${index}`} data-row-index={index}>
                                                  {this.renderRow(item, index)}
                                              </tr>
                                          );
                                      })
                                    : null}
                                {dataSource.length > 0 ? null : (
                                    <tr className={styles.nomore}>
                                        <td colSpan={columns.length}>{emptyText}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className={styles.tbody_wrapper} ref={this.ref_tbody}>
                        <table>
                            <thead className={styles.thead}>
                                <tr>
                                    {columns &&
                                        Array.isArray(columns) &&
                                        columns.map((item, index) => {
                                            return (
                                                <td
                                                    className={styles.td}
                                                    key={index}
                                                    style={{
                                                        width: item.width ? `${item.width}px` : '',
                                                    }}
                                                    data-col-index={index}>
                                                    {item.title}
                                                </td>
                                            );
                                        })}
                                </tr>
                            </thead>
                            <tbody>
                                {_dataSource && _dataSource.length
                                    ? _dataSource.map((item, index) => {
                                          return (
                                              <tr key={index} ref={`row-${index}`} data-row-index={index}>
                                                  {this.renderRow(item, index)}
                                              </tr>
                                          );
                                      })
                                    : null}
                                {dataSource.length > 0 ? null : (
                                    <tr className={styles.nomore}>
                                        <td colSpan={columns.length}>{emptyText}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Table);
